// AUTO-GENERATED from StreamNookBot/Commands (286 commands incl. subcommands, 13 categories).
// Regenerate rather than hand-editing.
export interface PenroseCommand { name: string; description: string }
export interface PenroseCommandCategory { category: string; commands: PenroseCommand[] }

export const PENROSE_COMMANDS: PenroseCommandCategory[] = [
  {
    "category": "Automod",
    "commands": [
      {
        "name": "antinuke add",
        "description": "Add an entity to the whitelist"
      },
      {
        "name": "antinuke disable",
        "description": "Disable a specific protection module"
      },
      {
        "name": "antinuke disable-all",
        "description": "Completely disable all Anti-Nuke protections"
      },
      {
        "name": "antinuke enable",
        "description": "Enable a specific protection module"
      },
      {
        "name": "antinuke list",
        "description": "View current whitelists"
      },
      {
        "name": "antinuke punishment",
        "description": "Change the global punishment type"
      },
      {
        "name": "antinuke remove",
        "description": "Remove an entity from the whitelist"
      },
      {
        "name": "antinuke setup",
        "description": "Enable the Anti-Nuke system and set the log channel"
      },
      {
        "name": "antinuke status",
        "description": "View the complete Anti-Nuke configuration status"
      },
      {
        "name": "antinuke threshold",
        "description": "Set trigger thresholds for a protection"
      },
      {
        "name": "automod anti-link",
        "description": "Block all types of links from being sent."
      },
      {
        "name": "automod disable",
        "description": "Disable a specific automod rule."
      },
      {
        "name": "automod flagged-words",
        "description": "Block profanity and slurs from being used."
      },
      {
        "name": "automod keyword",
        "description": "Block a keyword from being used."
      },
      {
        "name": "automod mention-spam",
        "description": "Block a certain amount of mentions from being used."
      },
      {
        "name": "automod spam-messages",
        "description": "Block messages from being spammed."
      },
      {
        "name": "automod spam-settings",
        "description": "Configure custom thresholds for message flooding."
      }
    ]
  },
  {
    "category": "Community",
    "commands": [
      {
        "name": "afk remove",
        "description": "Remove AFK within your server or globally"
      },
      {
        "name": "afk schedule",
        "description": "Set a recurring daily AFK schedule"
      },
      {
        "name": "afk schedule-remove",
        "description": "Remove your scheduled AFK"
      },
      {
        "name": "afk set",
        "description": "Go AFK within your server or globally"
      },
      {
        "name": "guildredeem",
        "description": "Redeem premium code for your guild"
      },
      {
        "name": "invite config",
        "description": "Configure invite system"
      },
      {
        "name": "invite count",
        "description": "Show total invites for a user"
      },
      {
        "name": "invite disable",
        "description": "Disable the invite system"
      },
      {
        "name": "invite leaderboard",
        "description": "Show top inviters"
      },
      {
        "name": "invite reset",
        "description": "Reset invite stats"
      },
      {
        "name": "leaderboard",
        "description": "Displays the top 10 members of the server as an image leaderboard."
      },
      {
        "name": "poll create",
        "description": "Creates a discord poll"
      },
      {
        "name": "poll end",
        "description": "Ends a discord poll"
      },
      {
        "name": "poll view-votes",
        "description": "Shows the results of a vote"
      },
      {
        "name": "profile",
        "description": "Show off a Twitch account's badges and 7TV paint, with their StreamNook profile"
      },
      {
        "name": "rank message",
        "description": ""
      },
      {
        "name": "rank voice",
        "description": ""
      },
      {
        "name": "redeem",
        "description": "Redeem a premium code for yourself or your server!"
      },
      {
        "name": "rep",
        "description": "Give a rep to a user"
      },
      {
        "name": "rep-stats",
        "description": "Check the reps and highest rating a user has"
      }
    ]
  },
  {
    "category": "Economy",
    "commands": [
      {
        "name": "economy add",
        "description": "Add an item to the shop (Admin)."
      },
      {
        "name": "economy addbalance",
        "description": "Add balance to a user (Admin only)."
      },
      {
        "name": "economy balance",
        "description": "Check your account balance."
      },
      {
        "name": "economy beg",
        "description": "Beg for some coins."
      },
      {
        "name": "economy blackjack",
        "description": "Play a game of blackjack."
      },
      {
        "name": "economy buy",
        "description": "Buy an item from the shop."
      },
      {
        "name": "economy coinflip",
        "description": "Flip a coin and bet on the outcome."
      },
      {
        "name": "economy daily",
        "description": "Collect your daily coins bonus."
      },
      {
        "name": "economy deleteacc",
        "description": "Delete your economy account."
      },
      {
        "name": "economy deposit",
        "description": "Deposit coins into your bank account."
      },
      {
        "name": "economy fish",
        "description": "Go fishing to earn coins."
      },
      {
        "name": "economy give",
        "description": "Give coins to another user."
      },
      {
        "name": "economy heist",
        "description": "Attempt a heist to steal coins."
      },
      {
        "name": "economy inventory",
        "description": "View your inventory."
      },
      {
        "name": "economy remove",
        "description": "Remove an item from the shop (Admin)."
      },
      {
        "name": "economy removebalance",
        "description": "Remove balance from a user (Admin only)."
      },
      {
        "name": "economy rob",
        "description": "Rob another user."
      },
      {
        "name": "economy roll",
        "description": "Roll a die and bet on the outcome."
      },
      {
        "name": "economy roulette",
        "description": "Play roulette and bet on a color."
      },
      {
        "name": "economy sell",
        "description": "Sell an item from your inventory."
      },
      {
        "name": "economy slots",
        "description": "Start the slot game."
      },
      {
        "name": "economy startacc",
        "description": "Create an economy user account."
      },
      {
        "name": "economy view",
        "description": "Browse items in the shop."
      },
      {
        "name": "economy withdraw",
        "description": "Withdraw coins from your bank account."
      },
      {
        "name": "economy work",
        "description": "Work to earn coins."
      }
    ]
  },
  {
    "category": "Fun",
    "commands": [
      {
        "name": "family divorce",
        "description": "Divorce your partner"
      },
      {
        "name": "family marry",
        "description": "Marry somebody"
      },
      {
        "name": "family relationships",
        "description": "${intUser} Wants to marry you! Do you accept their proposal?"
      },
      {
        "name": "fun advice",
        "description": "Get a random advice."
      },
      {
        "name": "fun coin-flip",
        "description": "Flip a coin."
      },
      {
        "name": "fun dice-roll",
        "description": "Roll a dice. (1~6) 🎲"
      },
      {
        "name": "fun joke",
        "description": "Get a funny joke 🤣"
      },
      {
        "name": "fun kiss",
        "description": "Kiss a user. 😘"
      },
      {
        "name": "fun pp-size",
        "description": "Shows the size of your pp."
      },
      {
        "name": "fun slap",
        "description": "Give the user a slap! 👋"
      },
      {
        "name": "games-multiplayer",
        "description": "Play a multi-player minigame within Discord. 🎮"
      },
      {
        "name": "games-singleplayer",
        "description": "Play a single-player minigame within Discord. 🎮"
      },
      {
        "name": "hack",
        "description": "Unlucky soul you want to hack."
      }
    ]
  },
  {
    "category": "Giveaway",
    "commands": [
      {
        "name": "giveaway edit",
        "description": "Edit a giveaway"
      },
      {
        "name": "giveaway end",
        "description": "End a giveaway early"
      },
      {
        "name": "giveaway reroll",
        "description": "Reroll a giveaway"
      },
      {
        "name": "giveaway start",
        "description": "Start a giveaway"
      }
    ]
  },
  {
    "category": "Images",
    "commands": [
      {
        "name": "images cat",
        "description": "Get a random cat image"
      },
      {
        "name": "images circle-crop",
        "description": "Select a user"
      },
      {
        "name": "images comrade",
        "description": "Select a user"
      },
      {
        "name": "images dog",
        "description": "Generates a random dog image"
      },
      {
        "name": "images fake-tweet",
        "description": "Post a real tweet 🐦"
      },
      {
        "name": "images fake-ytcomment",
        "description": "Post a real youtube comment 🔴"
      },
      {
        "name": "images gay",
        "description": "Select a user"
      },
      {
        "name": "images glass",
        "description": "Select a user"
      },
      {
        "name": "images jail",
        "description": "Select a user"
      },
      {
        "name": "images meme",
        "description": "Generates a meme image 😜"
      },
      {
        "name": "images passed",
        "description": "Select a user"
      },
      {
        "name": "images pixelate",
        "description": "Select a user"
      },
      {
        "name": "images triggered",
        "description": "Select a user"
      },
      {
        "name": "images wasted",
        "description": "Select a user"
      }
    ]
  },
  {
    "category": "Information",
    "commands": [
      {
        "name": "bot changelogs",
        "description": "Show last bot changelogs"
      },
      {
        "name": "bot feedback",
        "description": "Give feedback to my developer."
      },
      {
        "name": "bot info",
        "description": "Shows the status of the bot."
      },
      {
        "name": "bot invite",
        "description": "Invite our Bot to your servers"
      },
      {
        "name": "bot ping",
        "description": ""
      },
      {
        "name": "bot report-bug",
        "description": "Report a bug to the Developers of this Bot!"
      },
      {
        "name": "bot source-code",
        "description": "Want to buy the source code of this bot?"
      },
      {
        "name": "bot suggest",
        "description": "Suggest a feature"
      },
      {
        "name": "bot support",
        "description": "Get support server invite."
      },
      {
        "name": "bot uptime",
        "description": "Displays the bot uptime and system uptime"
      },
      {
        "name": "help",
        "description": "StreamNook Help Banner"
      },
      {
        "name": "serverinfo",
        "description": "Displays information about the server."
      },
      {
        "name": "userinfo",
        "description": "Get info of a member in the server."
      }
    ]
  },
  {
    "category": "Moderation",
    "commands": [
      {
        "name": "ban",
        "description": "Bans specified user."
      },
      {
        "name": "channel lock",
        "description": "Lock a channel."
      },
      {
        "name": "channel nuke",
        "description": "Deletes a channel and then clones it again (not a raid command)."
      },
      {
        "name": "channel unlock",
        "description": "Unlock a channel."
      },
      {
        "name": "kick",
        "description": "Kicks specified user."
      },
      {
        "name": "kickall",
        "description": "Kick all members except those with the specified role."
      },
      {
        "name": "lockdown blacklist-add",
        "description": "Adds a channel to the blacklist. Blacklisted channels will not be effected by the lockdown."
      },
      {
        "name": "lockdown blacklist-remove",
        "description": "Removes a channel from the blacklist. It will no longer be protected by the blacklist."
      },
      {
        "name": "lockdown commit",
        "description": "Locks down your server. Use with caution!"
      },
      {
        "name": "lockdown unlock",
        "description": "Unlockdowns your server."
      },
      {
        "name": "mass-unban",
        "description": "Unban all members in the server. Use with caution!"
      },
      {
        "name": "nick",
        "description": "❌ **Nickname Change Failed**\\n> ${description}"
      },
      {
        "name": "purge all",
        "description": "Remove all Messages"
      },
      {
        "name": "purge bot",
        "description": "Input count (1-100)"
      },
      {
        "name": "purge caps",
        "description": "Remove messages containing all capital letters"
      },
      {
        "name": "purge embed",
        "description": "Remove messages containing embeds"
      },
      {
        "name": "purge emojis",
        "description": "Remove messages containing emojis"
      },
      {
        "name": "purge images",
        "description": "Remove messages containing images/GIF/files"
      },
      {
        "name": "purge links",
        "description": "Remove messages containing links"
      },
      {
        "name": "purge mentions",
        "description": "Remove messages containing mentions"
      },
      {
        "name": "purge pins",
        "description": "Removes all pinned messages"
      },
      {
        "name": "purge reactions",
        "description": "Remove messages containing reactions"
      },
      {
        "name": "purge user",
        "description": "Removes all messages from the user given"
      },
      {
        "name": "role add",
        "description": "Gives a role to specified user."
      },
      {
        "name": "role create",
        "description": "Creates a role with specified details."
      },
      {
        "name": "role delete",
        "description": "Deletes specified role."
      },
      {
        "name": "role members",
        "description": "Displays the amount of people who have specified role.."
      },
      {
        "name": "role remove",
        "description": "Removes a user from specified role."
      },
      {
        "name": "roleall all",
        "description": "Assigns a specified role to all members (humans and bots)."
      },
      {
        "name": "roleall bots",
        "description": "Assigns a specified role to all bot members."
      },
      {
        "name": "roleall humans",
        "description": "Assigns a specified role to all human members."
      },
      {
        "name": "slowmode disable",
        "description": "Disable the slowmode of a channel"
      },
      {
        "name": "slowmode set",
        "description": "Set the slowmode of a channel"
      },
      {
        "name": "snipe",
        "description": "Snipes the last deleted message!"
      },
      {
        "name": "timeout",
        "description": "Times out a server member."
      },
      {
        "name": "unban",
        "description": "Unbans a member from your server"
      },
      {
        "name": "unroleall all",
        "description": "Removes a specified role from all members (humans and bots)."
      },
      {
        "name": "unroleall bots",
        "description": "Removes a specified role from all bot members."
      },
      {
        "name": "unroleall humans",
        "description": "Removes a specified role from all human members."
      },
      {
        "name": "untimeout",
        "description": "Untimesout a server member"
      },
      {
        "name": "warn clear",
        "description": "The user you want to clear the warnings of"
      },
      {
        "name": "warn show",
        "description": "The member you want to check the warnings of"
      },
      {
        "name": "warn toggle-auto",
        "description": "Toggle whether Automod triggers issue automatic warnings"
      },
      {
        "name": "warn user",
        "description": "Warn a user for their mistake or breaking any rule"
      }
    ]
  },
  {
    "category": "PremiumCommands",
    "commands": [
      {
        "name": "botprofile",
        "description": "The nickname for the bot in this server. (Leave empty to keep current)"
      },
      {
        "name": "imagine",
        "description": "Generates an image based on your prompt."
      },
      {
        "name": "premium-test",
        "description": "Test to see if you or your guild has premium!"
      },
      {
        "name": "uptime add",
        "description": "Add a URL to monitor"
      },
      {
        "name": "uptime delete",
        "description": "Remove a monitored URL"
      },
      {
        "name": "uptime info",
        "description": "Get detailed info for a URL"
      },
      {
        "name": "uptime list",
        "description": "List monitored URLs"
      },
      {
        "name": "uptime resetstats",
        "description": "Reset stats for a URL"
      },
      {
        "name": "uptime setalert",
        "description": "Toggle DM alerts for a URL"
      }
    ]
  },
  {
    "category": "Setups",
    "commands": [
      {
        "name": "ai-config",
        "description": "Configure Artificial Intelligence in your server!"
      },
      {
        "name": "anti-ghostping disable",
        "description": "Disable the anti ghost ping system"
      },
      {
        "name": "anti-ghostping number-reset",
        "description": "The user you want to reset the number of ghost pings of"
      },
      {
        "name": "anti-ghostping setup",
        "description": "Setup the anti ghost ping system"
      },
      {
        "name": "auto-responder add",
        "description": "Quickly add a simple text auto responder."
      },
      {
        "name": "auto-responder setup",
        "description": "Open the auto responder management panel."
      },
      {
        "name": "autorole add",
        "description": "Add an auto-role trigger"
      },
      {
        "name": "autorole disable",
        "description": "Disable the whole system"
      },
      {
        "name": "autorole list",
        "description": "List all the roles in the system."
      },
      {
        "name": "autorole remove",
        "description": "Remove an auto-role trigger"
      },
      {
        "name": "booster disable",
        "description": "Disable the booster notification system"
      },
      {
        "name": "booster set",
        "description": "Set the booster notification channel"
      },
      {
        "name": "counting disable",
        "description": "Disables the counting system for your server."
      },
      {
        "name": "counting setup",
        "description": "Sets up the counting system for you."
      },
      {
        "name": "guess disable",
        "description": "Disable guess the number"
      },
      {
        "name": "guess enable",
        "description": "Enable guess the number"
      },
      {
        "name": "join-ping add",
        "description": "User will receive a ping in specified channel when joining."
      },
      {
        "name": "join-ping disable",
        "description": "Disables all join pings. Use with caution."
      },
      {
        "name": "join-ping remove",
        "description": "User will stop receiving pings from specified channel when joining."
      },
      {
        "name": "join-to-create disable",
        "description": "Disables your join to create voice channel system."
      },
      {
        "name": "join-to-create setup",
        "description": "Sets up your join to create voice channel."
      },
      {
        "name": "leave-message",
        "description": "Configure the leave/goodbye message system"
      },
      {
        "name": "level-roles remove",
        "description": "Remove the level role system"
      },
      {
        "name": "level-roles set",
        "description": "Setup the level role system"
      },
      {
        "name": "level-roles view",
        "description": ":white_check_mark: Added Level Role(s)"
      },
      {
        "name": "leveling disable",
        "description": "Disables your leveling system."
      },
      {
        "name": "leveling disable-multiplier",
        "description": "Disables the multiplier of your role."
      },
      {
        "name": "leveling enable",
        "description": "Enables your leveling system."
      },
      {
        "name": "leveling give-xp",
        "description": "Give a user specified amount of XP."
      },
      {
        "name": "leveling prestige",
        "description": "Prestige to reset your level for a badge and XP bonus! (Requires Level 50+)"
      },
      {
        "name": "leveling reset-level",
        "description": "Reset the level of a user."
      },
      {
        "name": "leveling role-multiplier",
        "description": "Set up an XP multiplier for a specified role."
      },
      {
        "name": "logs config",
        "description": "Open the logging configuration panel."
      },
      {
        "name": "logs search",
        "description": "Search through server log history."
      },
      {
        "name": "modmail close",
        "description": "Closes your currently active modmail."
      },
      {
        "name": "modmail disable",
        "description": "Disables the modmail system of Rebelz."
      },
      {
        "name": "modmail setup",
        "description": "Sets up your modmail system of Rebelz."
      },
      {
        "name": "reaction-role add",
        "description": "Add a reaction role to a message"
      },
      {
        "name": "reaction-role add-role",
        "description": "Add a role to an existing menu"
      },
      {
        "name": "reaction-role create",
        "description": "Create a new role menu"
      },
      {
        "name": "reaction-role delete",
        "description": "Delete a role menu entirely"
      },
      {
        "name": "reaction-role list",
        "description": "List all role menus in this server"
      },
      {
        "name": "reaction-role remove",
        "description": "Remove a reaction role from a message"
      },
      {
        "name": "reaction-role remove-role",
        "description": "Remove a role from a menu"
      },
      {
        "name": "reaction-role send",
        "description": "Send or update the role menu message"
      },
      {
        "name": "serverstats add",
        "description": "Add a stats channel"
      },
      {
        "name": "serverstats edit",
        "description": "Stat type to edit"
      },
      {
        "name": "serverstats list",
        "description": "View all configured stats channels"
      },
      {
        "name": "serverstats remove",
        "description": "Remove a stats channel"
      },
      {
        "name": "serverstats reset",
        "description": "Remove all stats channels and delete the category"
      },
      {
        "name": "setup-apply",
        "description": "Configure and manage your server application systems"
      },
      {
        "name": "setup-autodelete",
        "description": "Configure automatic message deletion per channel"
      },
      {
        "name": "setup-menuapply",
        "description": "Create a selection menu for multiple application types"
      },
      {
        "name": "setup-smart-alerts disable",
        "description": "Disable Smart Alerts."
      },
      {
        "name": "setup-smart-alerts set",
        "description": "Set the alerts channel."
      },
      {
        "name": "setup-smart-alerts status",
        "description": "View current status of Smart Alerts."
      },
      {
        "name": "staff-role remove",
        "description": "Disables the staff help system."
      },
      {
        "name": "staff-role set",
        "description": "Specified role will be pinged when doing /help staff."
      },
      {
        "name": "starboard disable",
        "description": "Disable the starboard system."
      },
      {
        "name": "starboard emoji",
        "description": "Set the starboard reaction emoji."
      },
      {
        "name": "starboard enable",
        "description": "Enable the starboard and set the channel."
      },
      {
        "name": "starboard self-star",
        "description": "Toggle whether users can star their own messages."
      },
      {
        "name": "starboard settings",
        "description": "View current starboard settings."
      },
      {
        "name": "starboard threshold",
        "description": "Set the minimum number of stars required."
      },
      {
        "name": "sticky-message check",
        "description": "Check your active sticky messages"
      },
      {
        "name": "sticky-message disable",
        "description": "Remove a sticky message"
      },
      {
        "name": "sticky-message setup",
        "description": "Set a sticky message"
      },
      {
        "name": "streamnook claim",
        "description": "Link your Twitch account and claim your roles"
      },
      {
        "name": "streamnook status",
        "description": "Check your StreamNook link, subscription, and supporter status"
      },
      {
        "name": "streamnook sync",
        "description": "Admin: reconcile the StreamNook roles now"
      },
      {
        "name": "suggestion approve",
        "description": "Approve a suggestion by message ID."
      },
      {
        "name": "suggestion disable",
        "description": "Disable an already-existed suggestion channel."
      },
      {
        "name": "suggestion reject",
        "description": "Reject a suggestion by message ID."
      },
      {
        "name": "suggestion setup",
        "description": "Setup a suggestion system."
      },
      {
        "name": "suggestion submit",
        "description": "Submit a suggestion."
      },
      {
        "name": "ticket add",
        "description": "Add a user to the current ticket"
      },
      {
        "name": "ticket claim",
        "description": "Claim the current ticket"
      },
      {
        "name": "ticket close",
        "description": "Close the current ticket"
      },
      {
        "name": "ticket lock",
        "description": "Lock the current ticket"
      },
      {
        "name": "ticket remind",
        "description": "Remind the ticket owner about inactivity (closes after 24 hours)"
      },
      {
        "name": "ticket reopen",
        "description": "Reopen the current ticket"
      },
      {
        "name": "ticket setup",
        "description": "Setup the ticket system"
      },
      {
        "name": "ticket unlock",
        "description": "Unlock the current ticket"
      },
      {
        "name": "vanity disable",
        "description": "Turn off the vanity role system"
      },
      {
        "name": "vanity setup",
        "description": "Configure the vanity role"
      },
      {
        "name": "vanity status",
        "description": "Show the current vanity role configuration"
      },
      {
        "name": "verify-config",
        "description": "Configure your verification system using captcha."
      },
      {
        "name": "voiceleveling add-blacklist",
        "description": "Add a voice channel to the blacklist."
      },
      {
        "name": "voiceleveling disable",
        "description": "Disables the voice leveling system."
      },
      {
        "name": "voiceleveling enable",
        "description": "Enables the voice leveling system."
      },
      {
        "name": "voiceleveling remove-blacklist",
        "description": "Remove a voice channel from the blacklist."
      },
      {
        "name": "warnconfig add",
        "description": "Add an auto-punishment threshold."
      },
      {
        "name": "warnconfig decay",
        "description": "Configure automatic warn decay."
      },
      {
        "name": "warnconfig remove",
        "description": "Remove an auto-punishment threshold."
      },
      {
        "name": "warnconfig view",
        "description": "View current warn configuration."
      },
      {
        "name": "welcome-message",
        "description": "Configure the welcome message system"
      }
    ]
  },
  {
    "category": "Socials",
    "commands": [
      {
        "name": "twitch config",
        "description": "Configure Twitch notification settings."
      },
      {
        "name": "youtube config",
        "description": "Configure YouTube notification settings."
      }
    ]
  },
  {
    "category": "Tools",
    "commands": [
      {
        "name": "backup create",
        "description": "Creates a backup of the server settings."
      },
      {
        "name": "backup list",
        "description": "Lists all backups of the server settings."
      },
      {
        "name": "backup restore",
        "description": "Restores a backup of the server settings from states."
      },
      {
        "name": "embed",
        "description": "Create an embed"
      },
      {
        "name": "ocr",
        "description": "Extract text from an image"
      },
      {
        "name": "reminder cancel",
        "description": "Specified reminder will be cancelled."
      },
      {
        "name": "reminder cancel-all",
        "description": "Cancels all currently active reminders."
      },
      {
        "name": "reminder set",
        "description": "Sets up a reminder for you."
      },
      {
        "name": "tiktok download",
        "description": "Download a TikTok (no watermark)"
      },
      {
        "name": "tiktok random",
        "description": "A random trending TikTok (FYP)"
      },
      {
        "name": "tools calculator",
        "description": "A Discord calculator"
      },
      {
        "name": "tools decode",
        "description": "Decode a base64 string"
      },
      {
        "name": "tools docs",
        "description": "Searches the official Discord.JS documentation"
      },
      {
        "name": "tools encode",
        "description": "Encode a string to base64"
      },
      {
        "name": "tools iplookup",
        "description": "Looks up information about an IP address"
      },
      {
        "name": "tools mcstatus",
        "description": "Shows Minecraft Server Stats"
      },
      {
        "name": "tools password-generator",
        "description": "Generates a secure password for you"
      },
      {
        "name": "tools shorten",
        "description": "Shorten a URL using Bitly"
      },
      {
        "name": "tools translate",
        "description": "Translate any text to a specific language"
      },
      {
        "name": "tools tts",
        "description": "Sends text to speech messages in the server"
      },
      {
        "name": "tools weather",
        "description": "Gets the weather of a given area"
      }
    ]
  },
  {
    "category": "Utility",
    "commands": [
      {
        "name": "staff-help",
        "description": "Ping for help!"
      },
      {
        "name": "steal",
        "description": "Adds specified emoji to the server."
      },
      {
        "name": "utilities avatar",
        "description": "Select a user"
      },
      {
        "name": "utilities emoji-list",
        "description": "Displays guilds emojis."
      },
      {
        "name": "utilities enlarge",
        "description": "Enlarge an emoji"
      },
      {
        "name": "webhook create",
        "description": "Creates a webhook for specified channel."
      },
      {
        "name": "webhook delete",
        "description": "Deletes a webhook for you."
      },
      {
        "name": "webhook edit",
        "description": "Edits a webhook for you."
      }
    ]
  }
];
